import { DropdownItem } from "src/app/common/interfaces/dropdown-item.interface";
import { UserFacility } from "src/app/common/interfaces/user.interface";

// A user can belong to several corporations (RC-11021). Users who are not
// super admins or practitioners switch corporation from their own facility
// assignments, so these helpers derive the corporation choices from them.
// Mirrors rehabconnect-react `lib/corporationContext.ts`.

/** One option per corporation the user has facilities in, sorted by name. */
export function toCorporationOptions(
  facilities: readonly UserFacility[]
): DropdownItem[] {
  const byId = new Map<string, DropdownItem>();
  facilities.forEach((facility) => {
    if (facility.corpid && !byId.has(facility.corpid)) {
      byId.set(facility.corpid, {
        id: facility.corpid,
        name: facility.corporation || facility.corpid,
      });
    }
  });
  return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name));
}

/** The user's facilities within one corporation. */
export function facilitiesInCorporation(
  facilities: readonly UserFacility[],
  corporationId: string | null
): UserFacility[] {
  return facilities.filter((facility) => facility.corpid === corporationId);
}

/** The first candidate that is an available corporation, else the first option. */
export function pickCorporationId(
  candidates: readonly (string | null | undefined)[],
  options: readonly DropdownItem[]
): string {
  return (
    candidates.find(
      (id): id is string => !!id && options.some((option) => option.id === id)
    ) ??
    options[0]?.id ??
    ""
  );
}

/** The corporation's default facility, else its first facility. */
export function defaultFacilityId(facilities: readonly UserFacility[]): string {
  return (
    facilities.find((facility) => facility.isdefaultfacility)?.facilityid ??
    facilities[0]?.facilityid ??
    ""
  );
}
